import { apiClient } from '../../../../../services/apiClient'
import type { BuildingActivitySearchResponse } from '@popety-io/types'

export const buildingActivitiesService = {
  /**
   * Fetch activities for a specific building
   */
  getByBuildingId: async (
    buildingId: string
  ): Promise<BuildingActivitySearchResponse> => {
    try {
      const response = await apiClient.get(`/activities/building/${buildingId}`)
      return response.data
    } catch (error) {
      console.error('Get building activities by building ID error:', error)
      throw error
    }
  },
}
